import { render, staticRenderFns } from "./ActionSettingsList.vue?vue&type=template&id=027946de&scoped=true&"
import script from "./ActionSettingsList.vue?vue&type=script&lang=js&"
export * from "./ActionSettingsList.vue?vue&type=script&lang=js&"
import style0 from "./ActionSettingsList.vue?vue&type=style&index=0&id=027946de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027946de",
  null
  
)

export default component.exports